import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import style from './ui-attention-icon.css?inline';
import '../ui-sprite-svg/ui-sprite-svg';

const CName = 'ui-attention-icon';

export const AttentionIconName = {
  SUCCESS: 'success',
  TIME: 'time',
  WARNING: 'warning',
  ERROR: 'error',
  ERROR_X: 'error_x',
  INFORMATION: 'information',
} as const;

export type AttentionIconName = (typeof AttentionIconName)[keyof typeof AttentionIconName];

interface Icons {
  [key: string]: string;
}

const icons: Icons = {
  success: 'attention-success',
  time: 'attention-time',
  warning: 'attention-warning',
  error: 'attention-error',
  error_x: 'attention-error_x',
  information: 'attention-information',
};

@customElement(CName)
export class UiAttentionIcon extends LitElement {
  static readonly styles = [unsafeCSS(style)];

  @property({ type: String }) name: AttentionIconName = AttentionIconName.SUCCESS;
  @property({ type: String }) class = '';

  render() {
    const svgId = icons[this.name];

    return html`
      <div class="attention-icon ${this.class}">
        <ui-sprite-svg .class=${this.class} .iconID=${svgId}></ui-sprite-svg>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UiAttentionIcon;
  }
}
